export default "__VITE_ASSET__UPI3VPG4__"